import {
  faArrowTrendDown,
  faArrowTrendUp
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import {
  trend,
  trendNegative,
  trendNeutral,
  trendPositive
} from './TrendIndicator.css'

export const TrendIndicator = ({
  current,
  previous,
  invert = false
}: {
  current: number | null | undefined
  previous: number | null | undefined
  invert?: boolean
}): ReactElement | null => {
  if (
    current === null ||
    current === undefined ||
    previous === null ||
    previous === undefined ||
    previous === 0
  ) {
    return null
  }

  const delta = Math.round(((current - previous) / previous) * 100)

  if (delta === 0) {
    return <span className={clsx(trend, trendNeutral)}>=</span>
  }

  const isImprovement = invert ? delta < 0 : delta > 0

  return (
    <span
      className={clsx(trend, isImprovement ? trendPositive : trendNegative)}
    >
      <FontAwesomeIcon icon={delta > 0 ? faArrowTrendUp : faArrowTrendDown} />
      {delta > 0 ? '+' : ''}
      {delta} %
    </span>
  )
}
